var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildingStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 155,
    viewBox: "0 0 154 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 154,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5 29C68.6667 29 68.8333 29 69 29.1655C69.1667 29.3311 69.3333 29.4966 69.5 29.6621C69.6667 29.8276 69.6667 30.1587 69.8333 30.3242C69.8333 30.6553 70 30.9863 70 31.1519V123.517C70 123.848 70 124.014 69.8333 124.345C69.8333 124.676 69.6667 124.841 69.5 125.007C69.3333 125.172 69.1667 125.338 69 125.503C68.8333 125.669 68.6667 125.669 68.5 125.669H61.5C61.3333 125.669 61.1667 125.669 61 125.503C60.8333 125.338 60.6667 125.172 60.5 125.007C60.3333 125.007 60.3333 124.841 60.1667 124.51C60.1667 124.179 60 124.014 60 123.683V110.606H54.1667V123.683C54.1667 124.014 54.1667 124.179 54 124.51C54 124.841 53.8333 125.007 53.6667 125.172C53.5 125.338 53.3333 125.503 53.1667 125.669C53 125.834 52.8333 125.834 52.6667 125.834H23.3333C23.1667 125.834 23 125.834 22.8333 125.669C22.6667 125.503 22.5 125.338 22.3333 125.172C22.1667 125.007 22.1667 124.676 22 124.51C22 124.179 22 124.014 22 123.683V31.3174C22 30.9863 22 30.6553 22.1667 30.3242C22.1667 29.9932 22.3333 29.8276 22.5 29.6621C22.6667 29.4966 22.8333 29.3311 23 29.1655C23 29 23.1667 29 23.3333 29H68.5Z",
    fill: "#F78670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1654 31.814H24.832V126H51.6654V111.93C51.6654 111.599 51.6654 111.268 51.832 110.937C51.832 110.606 51.9987 110.44 52.1654 110.109C52.332 109.944 52.4987 109.778 52.6654 109.613C52.832 109.447 52.9987 109.447 53.1654 109.447H61.6654C61.832 109.447 61.9987 109.447 62.1654 109.613C62.332 109.778 62.4987 109.944 62.6654 110.109C62.832 110.275 62.832 110.606 62.9987 110.937C63.1654 111.268 63.1654 111.599 63.1654 111.93V126H67.332V31.814H67.1654Z",
    fill: "#F78670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 34.7935H43.5V38.9317H48.3333V34.7935Z",
    fill: "#02475E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 34.7935H29.832V38.9317H34.6654V34.7935Z",
    fill: "#02475E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 34.7935H57.1641V38.9317H61.9974V34.7935Z",
    fill: "#02475E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 86.7695H43.5V90.9078H48.3333V86.7695Z",
    fill: "#02475E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 86.7695H29.832V90.9078H34.6654V86.7695Z",
    fill: "#02475E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 86.7695H57.1641V90.9078H61.9974V86.7695Z",
    fill: "#02475E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 99.6809H43.5V103.819H48.3333V99.6809Z",
    fill: "#02475E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 99.6809H29.832V103.819H34.6654V99.6809Z",
    fill: "#02475E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 99.6809H57.1641V103.819H61.9974V99.6809Z",
    fill: "#02475E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 47.8701H43.5V52.0083H48.3333V47.8701Z",
    fill: "#02475E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 47.8701H29.832V52.0083H34.6654V47.8701Z",
    fill: "#02475E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 47.8701H57.1641V52.0083H61.9974V47.8701Z",
    fill: "#02475E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 60.7815H43.5V64.9197H48.3333V60.7815Z",
    fill: "#02475E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 60.7815H29.832V64.9197H34.6654V60.7815Z",
    fill: "#02475E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 60.7815H57.1641V64.9197H61.9974V60.7815Z",
    fill: "#02475E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3333 73.6929H43.5V77.8311H48.3333V73.6929Z",
    fill: "#02475E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6654 73.6929H29.832V77.8311H34.6654V73.6929Z",
    fill: "#02475E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9974 73.6929H57.1641V77.8311H61.9974V73.6929Z",
    fill: "#02475E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1667 126H52.8333C52.6667 126 52.5 125.834 52.5 125.669V109.447C52.5 109.281 52.6667 109.116 52.8333 109.116H62.1667C62.3333 109.116 62.5 109.281 62.5 109.447V125.669C62.5 125.834 62.3333 126 62.1667 126Z",
    fill: "#02475E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.832 113.089H95.332C94.9987 113.089 94.832 112.758 94.832 112.592V103.157C94.832 102.66 95.332 102.164 95.832 102.164H104.832C105.332 102.164 105.832 102.66 105.832 103.157V112.261C105.665 112.758 105.332 113.089 104.832 113.089Z",
    fill: "#F78670"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M99.168 102.329H101.335V105.474L100.168 104.647L99.168 105.474V102.329Z",
    fill: "#02475E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 113.089H108C107.667 113.089 107.5 112.758 107.5 112.592V103.157C107.5 102.66 108 102.164 108.5 102.164H117.5C118 102.164 118.5 102.66 118.5 103.157V112.261C118.333 112.758 118 113.089 117.5 113.089Z",
    fill: "#F78670"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.836 102.329H114.003V105.474L112.836 104.647L111.836 105.474V102.329Z",
    fill: "#02475E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M130.164 113.089H120.664C120.331 113.089 120.164 112.758 120.164 112.592V103.157C120.164 102.66 120.664 102.164 121.164 102.164H130.164C130.664 102.164 131.164 102.66 131.164 103.157V112.261C130.997 112.758 130.664 113.089 130.164 113.089Z",
    fill: "#F78670"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 102.329H126.667V105.474L125.5 104.647L124.5 105.474V102.329Z",
    fill: "#02475E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.832 100.343H95.332C94.9987 100.343 94.832 100.012 94.832 99.8463V90.4111C94.832 89.9146 95.332 89.418 95.832 89.418H104.832C105.332 89.418 105.832 89.9146 105.832 90.4111V99.5152C105.665 100.012 105.332 100.343 104.832 100.343Z",
    fill: "#F78670"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.168 89.418H101.335V92.7285L100.168 91.9009L99.168 92.7285V89.418Z",
    fill: "#02475E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 100.343H108C107.667 100.343 107.5 100.012 107.5 99.8463V90.4111C107.5 89.9146 108 89.418 108.5 89.418H117.5C118 89.418 118.5 89.9146 118.5 90.4111V99.5152C118.333 100.012 118 100.343 117.5 100.343Z",
    fill: "#F78670"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.836 89.418H114.003V92.7285L112.836 91.9009L111.836 92.7285V89.418Z",
    fill: "#02475E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M130.164 100.343H120.664C120.331 100.343 120.164 100.012 120.164 99.8463V90.4111C120.164 89.9146 120.664 89.418 121.164 89.418H130.164C130.664 89.418 131.164 89.9146 131.164 90.4111V99.5152C130.997 100.012 130.664 100.343 130.164 100.343Z",
    fill: "#F78670"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 89.418H126.667V92.7285L125.5 91.9009L124.5 92.7285V89.418Z",
    fill: "#02475E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.832 87.5973H95.332C94.9987 87.5973 94.832 87.2662 94.832 87.1007V77.6655C94.832 77.169 95.332 76.6724 95.832 76.6724H104.832C105.332 76.6724 105.832 77.169 105.832 77.6655V86.7696C105.665 87.2662 105.332 87.5973 104.832 87.5973Z",
    fill: "#F78670"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.168 76.6724H101.335V79.9829L100.168 79.1553L99.168 79.9829V76.6724Z",
    fill: "#02475E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 87.5973H108C107.667 87.5973 107.5 87.2662 107.5 87.1007V77.6655C107.5 77.169 108 76.6724 108.5 76.6724H117.5C118 76.6724 118.5 77.169 118.5 77.6655V86.7696C118.333 87.2662 118 87.5973 117.5 87.5973Z",
    fill: "#F78670"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M111.836 76.6724H114.003V79.9829L112.836 79.1553L111.836 79.9829V76.6724Z",
    fill: "#02475E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M130.164 87.5973H120.664C120.331 87.5973 120.164 87.2662 120.164 87.1007V77.6655C120.164 77.169 120.664 76.6724 121.164 76.6724H130.164C130.664 76.6724 131.164 77.169 131.164 77.6655V86.7696C130.997 87.2662 130.664 87.5973 130.164 87.5973Z",
    fill: "#F78670"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 76.6724H126.667V79.9829L125.5 79.1553L124.5 79.9829V76.6724Z",
    fill: "#02475E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.832 87.9282H89.832",
    stroke: "#02475E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M83.332 94.3839V81.3071",
    stroke: "#02475E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingStock);
export default __webpack_public_path__ + "static/media/Building+Stock.efe1784517f78a340f47d8b9858cfd5d.svg";
export { ForwardRef as ReactComponent };